import { loadable } from '../../../utils';

export const Select = loadable(() => import('./Select'), {});
export const Switch = loadable(() => import('./Switch'), {});
export const SelectedDisplay = loadable(() => import('./SelectedDisplay'), {});
export const BudgetDisplay = loadable(() => import('./BudgetDisplay'), {});
export const PriceChange = loadable(() => import('./PriceChange'), { type: 'text' });
